import React from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import '../styles/LoaderPage.css';

const LoaderPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Simulate loading time - changed to 3 seconds
    const timer = setTimeout(() => {
      navigate('/signup');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="intro-animation">
      {/* Background Image */}
      <div className="background-image"></div>

      {/* W Logo */}
      <img src="/images/logo.png" alt="Wiin Logo" className="w-logo" />
      
      {/* Brand Logos - 3 hovering logos */}
      <div className="brand-logos">
        <img src="/images/wolt.png" alt="Wolt" className="floating-logo logo-1" />
        <img src="/images/burger.png" alt="Burger" className="floating-logo logo-2" />
        <img src="/images/joe.png" alt="Joe & The Juice" className="floating-logo logo-3" />
      </div>
    </div>
  );
};

export default LoaderPage; 